import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskServiceInterface } from "./definitions/task-service-interface";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import draftToCalculationMutation from "./mutations/draft-to-calculation";
import { FetchResult } from '@apollo/client/core';

interface DraftToCalculationResponse {
  task: {
    draftToCalculation: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class DraftToCalculationService {
  constructor(private apollo: Apollo) {}

  draftToCalculation(
    taskId
  ): Observable<FetchResult<DraftToCalculationResponse>> {
    return this.apollo.mutate<DraftToCalculationResponse>({
      mutation: draftToCalculationMutation,
      variables: {
        taskId,
      },
    });
  }
}
